import { podcastOwnershipClaim, PodcastOwnershipResponse } from 'api/services';
import { useMutation, UseMutationOptions } from 'react-query';

export default function useSubmitPodcastOwnershipClaim(
  config?: Omit<
    UseMutationOptions<PodcastOwnershipResponse, unknown, string, unknown>,
    'mutationFn'
  >,
) {
  return useMutation<PodcastOwnershipResponse, unknown, string>(
    (podcastId) =>
      podcastOwnershipClaim({ podcastId, initiateOwnershipRequest: true }),

    config,
  );
}
